import { Flex, Typography, Image, Button } from "antd"
import EditIcon from "../../assets/icons/edit-icon.svg";

const { Text } = Typography

const DetailHeaderWithEdit = ({ title, handleEdit }) => {

    return (
        <Flex align="center" justify="space-between">
            <Text>{title}</Text>
            <Button
                type="text"
                icon={<Image src={EditIcon} alt="Edit" preview={false} />}
                onClick={handleEdit}
            />
        </Flex>
    )
}

export default DetailHeaderWithEdit